<template>
  <div id="documents" class="documents">
    <div class="file-table">
      <table>
        <tr>
          <td><span class="division-line">文件类型</span></td>
          <td><span class="division-line">文件名称</span></td>
          <td>上传时间</td>
        </tr>
        <tr v-for="(item,index) in customerFileList" :key="index">
          <td>{{ item.attachTypeName }}</td>
          <td @click="downloadFile(item)"><span class="blue">{{ item.originName }}</span></td>
          <td>{{ item.creatorTime }}</td>
        </tr>
      </table>
    </div>

    <el-popover trigger="hover" popper-class="tablepopover">
      <div class="columns-panle">
        <el-upload
          ref="upload"
          class="upload"
          :action="uploadAction"
          :data="{}"
          :on-success="(response, file, fileList) => handleSuccess(response, file, fileList)"
          :multiple="false"
          accept=".jpg,.jpeg,.gif,.png,.bmp,.pic,.doc,.docx,.rar,.xls,.xlsx,.pdf,.zip"
          :headers="{'Authorization': token}"
          :file-list="fileList"
        >
          <div class="list-item" @click="uploadType(13)">
            <span>发票</span>
          </div>
          <div class="list-item" @click="uploadType(12)">
            <span>装箱单</span>
          </div>
          <div class="list-item" @click="uploadType(7)">
            <span>其他</span>
          </div>
        </el-upload>
      </div>
      <div slot="reference" class="add-button">
        <button><span>+</span>添加文件</button>
      </div>
    </el-popover>
    <div class="documents-title">
      <span>收货后文件</span>
      <span>由平台上传的补充文件</span>
    </div>
    <div class="file-table">
      <table>
        <tr>
          <td><span class="division-line">文件类型</span></td>
          <td><span class="division-line">文件名称</span></td>
          <td>上传时间</td>
        </tr>
        <tr v-for="(item,index) in receiveFileList" :key="index">
          <td>{{ item.attachTypeName }}</td>
          <td @click="downloadFile(item)"><span class="blue">{{ item.originName }}</span></td>
          <td>{{ item.creatorTime }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {
  GetOrderAttach,
  UploadOrderAttach
} from '@/api/order.js'
import define from '@/utils/define'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Documents',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      customerFileList: [],
      receiveFileList: [],
      uploadAction: '',
      token: '',
      fileList: [],
      attachType: undefined
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.uploadAction = define.comUrl + '/api/file/Uploader/customer'
    this.token = getCookie('token')
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    uploadType(type) {
      this.attachType = type
    },
    handleSuccess(response, file, fileList) {
      if (response.code === 200) {
        var file = [{
          objectId: this.data.orderNo,
          attachType: this.attachType,
          originName: file.name,
          buildName: response.data.name,
          url: response.data.url,
          uploadType: 1
        }]
        UploadOrderAttach(file).then(res => {
          if (res.code === 200) {
            this.init(this.data)
          }
        })
      }
    },
    init(data) {
      this.data = data
      GetOrderAttach(data.orderNo).then(res => {
        if (res.code === 200) {
          this.customerFileList = res.data.filter(item => item.uploadType === 1)
          this.receiveFileList = res.data.filter(item => item.uploadType === 2)
        }
      })
    },
    downloadFile(item) {
      this.xms.downloadFile(item.url)
    }
  }
}
</script>
<style scoped lang='scss'>
	.documents {
		padding: 8px 24px 8px 32px;

		.file-table {
			border: 1px solid rgba(221, 221, 221, 0.56);
			border-radius: 8px;

			table {
				width: 100%;
				border-collapse: collapse;
				text-align: left;
				padding: 0 8px;

				tr:nth-of-type(1) {
					td {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #777777;
						background: rgba(221, 221, 221, 0.24);

					}
				}

				tr {
					height: 40px;

					td {
						padding-left: 8px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;

						.division-line {
							display: inline-block;
							height: 20px;
							width: 100%;
							border-right: 1px solid #DDDDDD;
						}

						.blue {
							color: #027FFC;
							cursor: pointer;
						}
					}

					td:nth-of-type(1),
					td:nth-of-type(3) {
						width: 200px;
					}

					td:nth-of-type(2) {
						width: 744px;
					}
				}
			}
		}

		.add-button {
			text-align: right;

			button {
				width: 200px;
				height: 32px;
				background: rgba(2, 127, 252, 0);
				border-radius: 8px;
				border: 1px solid rgba(2, 127, 252, 0.4);
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #027FFC;
				margin: 8px 0px 16px 0;

				span {
					margin-right: 4px;
				}
			}
		}

		.documents-title {
			text-align: left;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			margin-bottom: 8px;

			span:nth-of-type(1) {
				font-weight: 500;
				color: #333333;
			}

			span:nth-of-type(2) {
				font-weight: 400;
				color: #777777;
			}
		}

	}

	.columns-panle {
		width: 200px;
		height: auto;
		background: #FFFFFF;
		box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
		border-radius: 8px;
		border: 1px solid rgba(221, 221, 221, 0.56);
		z-index: 100;
		position: absolute;
		top: -25px;
		left: 372px;
		padding: 6px 0;

		.list-item {
			cursor: pointer;
			height: 33px;
			line-height: 33px;
			background: rgba(255, 255, 255, 0);
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
			line-height: 22px;
			text-align: left;
			display: flex;
			align-items: center;
			padding-right: 12px;
			padding-left: 15px;
			width: 173px;

			&:hover {
				background: #F7F8FA;
				border-radius: 4px;
			}
		}
	}
</style>
